import { render } from "./FlightsCatalog.vue?vue&type=template&id=f486bdec"
import script from "./FlightsCatalog.vue?vue&type=script&lang=js"
export * from "./FlightsCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__